/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY_FOR_PAGE = 'viewedProductsForPage';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS_FOR_PAGE = 20;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  /**
   * Adds a product object to the recently viewed products list.
   * @param {{ marketing_title: string, country_of_origin: string, price_per_yard: string, handle: string }} product - The product object to add.
   */
  static addProductForPage(product) {
    // Update page-specific recently viewed products
    let viewedProductsForPage = this.getProductsForPage();
    viewedProductsForPage = viewedProductsForPage.filter((p) => p.handle !== product.handle);
    viewedProductsForPage.unshift(product);
    viewedProductsForPage = viewedProductsForPage.slice(0, this.#MAX_PRODUCTS_FOR_PAGE);
    localStorage.setItem(this.#STORAGE_KEY_FOR_PAGE, JSON.stringify(viewedProductsForPage));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
    // localStorage.removeItem(this.#STORAGE_KEY_FOR_PAGE);
  }

  /**
   * Retrieves the list of recently viewed products from storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }

  /**
   * Retrieves the list of recently viewed products for the page from storage.
   * @returns {{ marketing_title: string, country_of_origin: string, price_per_yard: string, handle: string }[]} The list of viewed products for the page.
   */
  static getProductsForPage() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY_FOR_PAGE) || '[]');
  }
}
